var _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M1 7h1M1 8h1M1 9h1M1 10h1M3 10h2M2 11h1M4 11h1M1 12h1M1 13h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.00784313725490196)",
    d: "M3 7h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.00392156862745098)",
    d: "M2 10h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.9294117647058824)",
    d: "M1 11h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(85,85,85,0.023529411764705882)",
    d: "M3 11h1M3 12h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    d: "M4 12h1M3 13h1M1 14h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.0196078431372549)",
    d: "M2 13h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#272727",
    d: "M2 14h1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat);
export default __webpack_public_path__ + "static/media/flat.f8131d5d453d7868d37a235faa57a633.svg";
export { ForwardRef as ReactComponent };